import React from 'react';
import HomeOpenHours from '../components/HomeOpenHours';
import ScrollIntoView from '../components/ScrollIntoView';

const Home = () => {
  return (
    <ScrollIntoView>

      <div id="home-page">

        <section id="home-actual">
          <h1>Aktuális</h1>

          <article>
            <h2>Hulladékszállítás</h2>
            
            <p>Tájékoztatjuk Önöket, hogy hulladékszállítási közszolgáltatási tevékenységet a Kisújszállási Városgazdálkodási Nonprofit Kft. már <b>nem végez</b>, <span style={{color:"rgb(233, 15, 15)"}}>telephelyünkön az ügyfélszolgálat megszűnt.</span></p>
            <p>Hulladékszállítási ügyek intézésével, keressék az NHSZ Tisza Nonprofit Kft-t a számlán található elérhetőségek valamelyikén, vagy a <a href="https://www.nhsztisza.hu/new/ugyfelszolgalat/szemelyes-ugyfelszolgalat/" target="_blank" rel="noopener noreferrer">www.nhsztisza.hu/new/ugyfelszolgalat/szemelyes-ugyfelszolgalat/</a> honlapon.</p>
            <p>Lehetőségük van a hulladék elszállítását ténylegesen végző Karcag Térségi Hulladékgazdálkodási Közszolgáltató Nonprofit Kft.-t is megkeresni a <a href="https://www.ktkkft.hu/" target="_blank" rel="noopener noreferrer">https://www.ktkkft.hu/</a> honlapon vagy az alábbi elérhetőségeken.</p>
            <p>Ügyfélszolgálat: <b>NHSZ Tisza Nonprofit Kft. 5310 Kisújszállás, Kálvin u. 2. üzletsor 6-os üzlet.</b></p>
            <p>Ügyfélszolgálati telefonszám: <a href="tel:+30/710-29-67">30/710-29-67</a></p>
            <p>Ügyfélszolgálati E-mail cím: <a href="mailto:kisujszallas@ktkkft.hu">kisujszallas@ktkkft.hu </a></p>
          </article>

          <article>
            <h2>Virágbolt</h2>
            <p><a target="_blank" href="https://www.facebook.com/Borosty%C3%A1n-Vir%C3%A1gbolt-101413431450608/">Tekintse meg aktuális kínálatunkat a Facebook oldalunkon!</a></p>
          </article>

        </section>

        <section id="home-office">
        </section>

        <HomeOpenHours />

      </div>
    </ScrollIntoView>
  );
};

export default Home;